import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  root: {
    height: '584px',
    position: 'relative',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  loaderHolder: {
    width: '100%',
    height: 260,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
